var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'trial-figure',
    ("size-" + _vm.size),
    ("color-" + _vm.color),
    _vm.cursorPointer && 'cursor' ]},[_c('span',{class:[
      'text',
      'text_light',
      'trial-figure-title',
      ("size-" + _vm.size) ]},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }